import { render, staticRenderFns } from "./GoodsPromotion.vue?vue&type=template&id=06bb6716&"
import script from "./GoodsPromotion.vue?vue&type=script&lang=js&"
export * from "./GoodsPromotion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports